import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["index"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.object.keys.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-slider.
* homepage: https://github.com/react-component/slider
*/
import React from 'react';
import PropTypes from 'prop-types';
import addEventListener from './addEventListener';
import classNames from 'classnames';
import warning from 'warning';
import Icon from '../../../wui-icon/src';
import Steps from './Steps';
import Marks from './Marks';
import Handle from '../Handle';
import * as utils from '../utils';
import { prefix } from "../../../wui-core/src/index.js";

function noop() {}

export default function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(ComponentEnhancer, _Component);

    var _super = _createSuper(ComponentEnhancer);

    //这里是超级关键的：采用高阶组件的写法
    function ComponentEnhancer(props) {
      var _this;

      _classCallCheck(this, ComponentEnhancer);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
        //鼠标落下的操作
        //指示当事件被触发时哪个鼠标按键被点击 
        //参数  描述
        //0     规定鼠标左键。
        //1     规定鼠标中键。
        //2     规定鼠标右键。
        if (e.button !== 0) {
          return;
        } //1.getMousePosition：获得鼠标的位置 clientY或者pageX
        //2.isEventFromHandle：是直接落下还是拖动handle
        //3.getHandleCenterPosition:获得handle的中点位置
        //4.onStart：在slider.jsx中


        var isVertical = _this.props.vertical;
        var position = utils.getMousePosition(isVertical, e);

        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target); //handle的位置

          _this.dragOffset = position - handlePosition; //鼠标落下的位置-handle的中间位置，这是偏差

          position = handlePosition; //position是
        }

        _this.onStart(position);

        _this.addDocumentMouseEvents();

        utils.pauseEvent(e);
      });

      _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
        //touch事件
        //event.touches，多点触碰时的位置数组，比如缩放手势必须要用两指的触摸点，就是一个数组
        //多点触碰不算
        if (utils.isNotTouchEvent(e)) return; //1.getMousePosition：获得鼠标的位置 clientY或者pageX
        //2.isEventFromHandle：是直接落下还是拖动handle
        //3.getHandleCenterPosition:获得handle的中点位置
        //4.onStart：在slider.jsx中

        var isVertical = _this.props.vertical;
        var position = utils.getTouchPosition(isVertical, e);

        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }

        _this.onStart(position);

        _this.addDocumentTouchEvents();

        utils.pauseEvent(e);
      });

      _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();

          return;
        }

        var position = utils.getMousePosition(_this.props.vertical, e);

        _this.onMove(e, position - _this.dragOffset);
      });

      _defineProperty(_assertThisInitialized(_this), "onTouchMove", function (e) {
        //1.isNotTouchEvent：是不是touch事件
        //2.getTouchPosition：return vertical ? e.touches[0].clientY : e.touches[0].pageX;
        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
          _this.onEnd();

          return;
        }

        var position = utils.getTouchPosition(_this.props.vertical, e);

        _this.onMove(e, position - _this.dragOffset);
      });

      _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
        //对应不同的keycode
        if (_this.sliderRef && utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "onFocus", function (e) {
        //Focus事件
        //1.isEventFromHandle：是直接落下还是拖动handle
        //2.getHandleCenterPosition:获得handle的中点位置
        //3.onStart：在slider.jsx中
        var isVertical = _this.props.vertical;

        if (utils.isEventFromHandle(e, _this.handlesRefs)) {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = 0;

          _this.onStart(handlePosition);

          utils.pauseEvent(e);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
        _this.onEnd(e);
      });

      _defineProperty(_assertThisInitialized(_this), "saveSlider", function (slider) {
        _this.sliderRef = slider;
      });

      if (process.env.NODE_ENV !== 'production') {
        var step = props.step,
            max = props.max,
            min = props.min;
        warning(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      }

      _this.handlesRefs = {};
      return _this;
    }

    _createClass(ComponentEnhancer, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (_get(_getPrototypeOf(ComponentEnhancer.prototype), "componentWillUnmount", this)) _get(_getPrototypeOf(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: "addDocumentTouchEvents",
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = addEventListener(document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = addEventListener(document, 'touchend', this.onEnd);
      }
    }, {
      key: "addDocumentMouseEvents",
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = addEventListener(document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = addEventListener(document, 'mouseup', this.onEnd);
      }
    }, {
      key: "removeDocumentEvents",
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();
        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      } //slider的开始位置

    }, {
      key: "getSliderStart",
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var rect = slider.getBoundingClientRect();
        return this.props.vertical ? this.props.reverse ? rect.bottom : rect.top : this.props.reverse ? rect.right : rect.left;
      } //slider的高度

    }, {
      key: "getSliderLength",
      value: function getSliderLength() {
        var slider = this.sliderRef;

        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      } //计算实际的value值

    }, {
      key: "calcValue",
      value: function calcValue(offset) {
        var _this$props = this.props,
            vertical = _this$props.vertical,
            min = _this$props.min,
            max = _this$props.max;
        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      } //这里才是最终的value

    }, {
      key: "calcValueByPos",
      value: function calcValueByPos(position) {
        //mouseposition 或者 handlePosition - slider的top（或者left）；
        var pixelOffset = this.props.reverse ? this.getSliderStart() - position : position - this.getSliderStart(); //calValue()：radio来算出真正的value
        //trimAlignValue()：在slider.jsx中1.ensureValueInRange 先算出是否可取 v 或者 min 或者 max 2.ensureValuePrecision：来获取真的前进数值closest数值

        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: "calcOffset",
      value: function calcOffset(value) {
        var _this$props2 = this.props,
            min = _this$props2.min,
            max = _this$props2.max;
        var ratio = (value - min) / (max - min);
        return ratio * 100;
      }
    }, {
      key: "saveHandle",
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: "clearValue",
      value: function clearValue(e) {
        var disabled = this.props.disabled;
        if (disabled) return;
        this.clearSliderValue();
      }
    }, {
      key: "render",
      value: function render() {
        var _classNames,
            _classNames3,
            _this2 = this;

        var _this$props3 = this.props,
            prefixCls = _this$props3.prefixCls,
            className = _this$props3.className,
            marks = _this$props3.marks,
            dots = _this$props3.dots,
            step = _this$props3.step,
            included = _this$props3.included,
            disabled = _this$props3.disabled,
            vertical = _this$props3.vertical,
            reverse = _this$props3.reverse,
            min = _this$props3.min,
            max = _this$props3.max,
            children = _this$props3.children,
            style = _this$props3.style,
            railStyle = _this$props3.railStyle,
            dotStyle = _this$props3.dotStyle,
            allowClear = _this$props3.allowClear,
            range = _this$props3.range,
            activeDotStyle = _this$props3.activeDotStyle;

        var _get$call = _get(_getPrototypeOf(ComponentEnhancer.prototype), "render", this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var showClear = !!allowClear && !range;
        var sliderClassName = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), vertical), _defineProperty(_classNames, "".concat(prefixCls, "-clear"), showClear), _defineProperty(_classNames, className, className), _classNames));
        var sliderWrapperClassName = classNames("".concat(prefixCls, "-wrapper"), _defineProperty({}, "".concat(prefixCls, "-wrapper-vertical"), vertical));
        var sliderIconClassName = classNames("".concat(prefixCls, "-clear-icon"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-clear-disabled"), disabled), _defineProperty(_classNames3, "".concat(prefixCls, "-clear-vertical"), vertical), _classNames3));
        var sliderDom = /*#__PURE__*/React.createElement("div", {
          ref: this.saveSlider,
          className: sliderClassName,
          onTouchStart: disabled ? noop : this.onTouchStart,
          onMouseDown: disabled ? noop : this.onMouseDown,
          onKeyDown: disabled ? noop : this.onKeyDown,
          onFocus: disabled ? noop : this.onFocus,
          onBlur: disabled ? noop : this.onBlur,
          style: style
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-rail"),
          style: _objectSpread({}, railStyle)
        }), tracks, /*#__PURE__*/React.createElement(Steps, {
          prefixCls: prefixCls,
          vertical: vertical,
          reverse: reverse,
          marks: marks,
          dots: dots,
          step: step,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min,
          dotStyle: dotStyle,
          activeDotStyle: activeDotStyle
        }), handles, /*#__PURE__*/React.createElement(Marks, {
          className: "".concat(prefixCls, "-mark"),
          vertical: vertical,
          reverse: reverse,
          marks: marks,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min
        }), children);

        if (showClear) {
          return /*#__PURE__*/React.createElement("div", {
            className: sliderWrapperClassName
          }, sliderDom, /*#__PURE__*/React.createElement("div", {
            className: sliderIconClassName,
            onClick: function onClick(e) {
              return _this2.clearValue(e);
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            type: "uf-close-c"
          })));
        } else {
          return sliderDom;
        }
      }
    }]);

    return ComponentEnhancer;
  }(Component), _defineProperty(_class, "displayName", "ComponentEnhancer(".concat(Component.displayName, ")")), _defineProperty(_class, "propTypes", _objectSpread(_objectSpread({}, Component.propTypes), {}, {
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    marks: PropTypes.object,
    included: PropTypes.bool,
    className: PropTypes.string,
    prefixCls: PropTypes.string,
    disabled: PropTypes.bool,
    children: PropTypes.any,
    onBeforeChange: PropTypes.func,
    onChange: PropTypes.func,
    onAfterChange: PropTypes.func,
    handle: PropTypes.func,
    dots: PropTypes.bool,
    vertical: PropTypes.bool,
    reverse: PropTypes.bool,
    allowClear: PropTypes.bool,
    style: PropTypes.object,
    //minimumTrackStyle: PropTypes.object, // just for compatibility, will be deperecate
    //maximumTrackStyle: PropTypes.object, // just for compatibility, will be deperecate
    handleStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    trackStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    railStyle: PropTypes.object,
    dotStyle: PropTypes.object,
    activeDotStyle: PropTypes.object
  })), _defineProperty(_class, "defaultProps", _objectSpread(_objectSpread({}, Component.defaultProps), {}, {
    prefixCls: "".concat(prefix, "-slider"),
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = _objectWithoutProperties(_ref, _excluded);

      delete restProps.dragging;
      return /*#__PURE__*/React.createElement(Handle, _extends({}, restProps, {
        key: index
      }));
    },
    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    allowClear: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  })), _temp;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-slider/src/common/createSlider.js